/** Histórico de múltiplas salvas na Gestão (versão para migrações). */
export const SAVED_MULTIPLES_STORAGE_KEY = 'kickstats_saved_multiples_v1';

export function loadSavedMultiples() {
  try {
    const raw = localStorage.getItem(SAVED_MULTIPLES_STORAGE_KEY);
    if (!raw) return [];
    const data = JSON.parse(raw);
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

/** Leg mínima para persistência (sem refs pesadas). */
export function legToSnapshot(leg) {
  return {
    id: leg.id,
    label: leg.label,
    decimalOdd: leg.decimalOdd,
    source: leg.source,
  };
}

/** Data local → YYYY-MM-DD (registro / filtro). */
export function toReferenceDateKey(d) {
  if (!d) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function parseReferenceDateKey(s) {
  if (!s || !/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d, 12, 0, 0, 0);
}

/**
 * Lucro em R$ após marcar resultado: green = múltipla ganha, red = perdeu o stake; pendente = 0.
 */
export function profitFromSnapshotOutcome(s) {
  const stake = Number(s.stake) || 0;
  if (s.outcome === 'green') {
    const ep = s.estimatedProfit != null ? Number(s.estimatedProfit) : null;
    if (ep != null && Number.isFinite(ep)) return ep;
    const gr = s.grossReturn != null ? Number(s.grossReturn) : null;
    if (gr != null && Number.isFinite(gr)) return gr - stake;
    return 0;
  }
  if (s.outcome === 'red') return -stake;
  return 0;
}
